import { Alert, Box, Stack, Typography } from "@mui/material"
import { ArticleResult } from "interface/article"
import { MeshChip } from "features/article/components/meshChip"
import { ArticlesAuthorList } from "./authorList"
import { useArticlePreview } from "../container"

type ArticlePreviewBodyProps = {
	article: ArticleResult
	container: ReturnType<typeof useArticlePreview>
}
export const ArticlePreviewBody = ({
	article,
	container: {
		targetSisetuCode,
		targetKojinCode,
		targetAuthorId,
		onKojinOpen, onAuthorOpen
	}
}: ArticlePreviewBodyProps) => {
	return (
		<Stack direction='column' padding={1} spacing={1} flexGrow={1} overflow='auto'>
			<Box>
				<ArticlesAuthorList
					article={article}
					targetSisetuCode={targetSisetuCode}
					targetKojinCode={targetKojinCode}
					targetAuthorId={targetAuthorId}
					onKojinOpen={onKojinOpen} onAuthorOpen={onAuthorOpen}
				/>
			</Box>
			<Stack direction='column' spacing={2}>
				{article.journal.title ? (
					<Box>
						<Typography variant='caption' component='div' color='text.secondary' translate='yes'>Journal:</Typography>
						<Typography variant='body2' paddingX={1} component='div' translate='yes'>
							{[
								article.journal.dateText || [],
								article.journal.title,
								article.journal.issue || [],
								article.pagination || []
							].flat().join(' ')}
						</Typography>
					</Box>
				) : <></> }

				{(article.sections && article.sections.length > 0) ? (
					article.sections.map((section, j) => (
						<Box key={`section-${j}`}>
							<Typography variant='caption' component='div' color='text.secondary' translate='yes'>{section.label ?? 'Abstract'}:</Typography>
							{section.textJpn ? (
								<Stack direction='column' paddingX={1}>
									<Typography variant='body1' component='div' color='text.primary' whiteSpace='pre-wrap'>{section.textJpn}</Typography>
									<Typography variant='body2' component='div' color='text.secondary' whiteSpace='pre-wrap'>{section.text}</Typography>
								</Stack>
							) : (
								<Typography variant='body2' paddingX={1} component='div' color='text.primary' translate='yes' whiteSpace='pre-wrap'>{section.text}</Typography>
							)}
						</Box>
					))
				) : (article.abstract || article.abstractJpn) ? (
					<Box>
						<Typography variant='caption' component='div' color='text.secondary' translate='yes'>Abstract:</Typography>
						{article.abstractJpn ? (
							<Stack direction='column' paddingX={1}>
								<Typography variant='body1' component='div' color='text.primary' whiteSpace='pre-wrap'>{article.abstractJpn}</Typography>
								<Typography variant='body2' component='div' color='text.secondary' whiteSpace='pre-wrap'>{article.abstract}</Typography>
							</Stack>
						) : (
							<Typography variant='body2' paddingX={1} component='div' color='text.primary' translate='yes' whiteSpace='pre-wrap'>{article.abstract}</Typography>
						)}
					</Box>
				) : (
					<Box>
						<Alert severity="info">Abstractはありません</Alert>
					</Box>
				) }

				{article.meshs && article.meshs.length > 0 ? (
					<Box>
						<Typography variant='caption' component='span' color='text.secondary'>MESH:</Typography>
						<Stack direction="row" alignItems='flex-start' flexWrap='wrap' useFlexGap>
							{ article.meshs.map((mesh, i) => <MeshChip key={`mesh-${i}`} mesh={mesh} marginLeft={1}/>) }
						</Stack>
					</Box>
				) : <></> }
			</Stack>
		</Stack>
	)
}